/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, Heading, HFlow, Icon, Text, useTheme, VFlow } from 'bold-ui'
import { identidadeGenero, sexo } from 'types/enums'
import { formatDate } from 'util/date/formatDate'

import { CidadaoListagemGeralQueryModel } from '../../model/model-acompanhamentoCondicaoSaudeListaTematica'
import { renderTelefone } from '../table/render-acompanhamentoCondicaoSaudeColumns'

interface AcompanhamentoCondicaoSaudeDadosCadastraisAccordionSectionProps {
  row: CidadaoListagemGeralQueryModel
}

export function AcompanhamentoCondicaoSaudeDadosCadastraisAccordionSection(
  props: Readonly<AcompanhamentoCondicaoSaudeDadosCadastraisAccordionSectionProps>
) {
  const { row } = props
  const theme = useTheme()
  const classes = styles()

  return (
    <Grid key={row.cnsCidadao} gap={0} alignItems='baseline' style={classes.grid}>
      <Cell size={12} style={classes.item}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='userCardFilled' color={theme.pallete.gray.c20} />
          <Heading level={5}>Dados cadastrais</Heading>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Telefone</Text>
          <Text>{renderTelefone(row)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Endereço</Text>
          <Text>{row.endereco?.titleCase()}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Data de nascimento</Text>
          <Text>{formatDate(row.dataNascimentoCidadao)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Sexo e identidade de gênero</Text>
          <Text>
            {sexo[row.sexoCidadao]}
            {row.identidadeGeneroCidadao && ' | ' + identidadeGenero[row.identidadeGeneroCidadao]}
          </Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}

const styles = () => ({
  grid: css`
    margin: 0;
    padding-top: 0.25rem;
    padding-textottom: 0.25rem;
  `,
  item: css`
    padding: 0.5rem 0 0;
  `,
})
